import { render, staticRenderFns } from "./settingsDialog.vue?vue&type=template&id=e6fc36b4&scoped=true"
import script from "./settingsDialog.vue?vue&type=script&lang=js"
export * from "./settingsDialog.vue?vue&type=script&lang=js"
import style0 from "./settingsDialog.vue?vue&type=style&index=0&id=e6fc36b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fc36b4",
  null
  
)

export default component.exports